module.exports = __webpack_public_path__ + "img/2025-03-11-02-01.ce59ef4a.png";